import { magicLinkClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';
import { apiBaseUrl } from './api';

/** App do cliente: entrada só por link mágico no e-mail (sem passkey obrigatória). */
export const authClient = createAuthClient({
  baseURL: `${apiBaseUrl()}/auth`,
  fetchOptions: { credentials: 'include' },
  plugins: [magicLinkClient()],
});
